import React, { useState } from "react";
import { Modal, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  useUserData,
  useUpdateUserData,
} from "components/customHooks/userDataContext";
import {
  getPracticeLocationsPatient,
  getPracticeProviders,
  getPracticeTemplate,
} from "apiHandler/actions";
import { useDispatch } from "react-redux";
import {
  setCountryCode,
  setPracticeTimezone,
} from "../redux/reducers/practice";

const PracticeRedirectPage = ({ onCloseModal }) => {
  const [select, setSelect] = useState("");
  const [openModal, setOpenModal] = useState(true);
  const navigate = useNavigate();
  const userData = useUserData();
  const setUserData = useUpdateUserData();
  const practices = userData.practices;
  const dispatch = useDispatch();
  const id_token = userData?.access_token;

  const handleOnClick = async () => {
    setOpenModal(false);
    navigate("/timesheet");
  };

  const handleSelect = () => {
    setUserData({
      selected_practice: select,
      selected_practice_name: practices.find(
        (p) => p.practice_id.toString() === select,
      )?.practice_name,
    });
    fetchPracticeDetails(select);
    navigate("/main-dashboard");
  };

  const fetchPracticeDetails = async (practice_id) => {
    if (!practice_id) return;
    const practice_locations = await getPracticeLocationsPatient(
      {
        practice_id,
      },
      id_token,
    );
    const practice_providers = await getPracticeProviders(
      {
        practice_id,
      },
      id_token,
    );
    const practice_template = await getPracticeTemplate(
      {
        practice_id,
      },
      id_token,
    );
    setUserData({ practice_locations, practice_providers, practice_template });
  };

  const onSelectPractice = (e) => {
    const selectedPracticeObj = practices.find(
      (item) => item.practice_id.toString() === e.target.value,
    );
    setSelect(e.target.value);
    if (selectedPracticeObj.practice_timezone) {
      const tz = selectedPracticeObj.practice_timezone_description;
      const countryCode = selectedPracticeObj.country_code || "US";
      dispatch(setPracticeTimezone(tz));
      dispatch(setCountryCode(countryCode));
      localStorage.setItem("practice_timezone", tz);
      localStorage.setItem("country_code", countryCode);
    }
  };

  const onClose = () => {
    if (onCloseModal) {
      onCloseModal();
    }
  };

  if (!practices || practices.length === 0) {
    return (
      <Modal open={openModal} onClose={onClose}>
        <div className="sel-practice-modal">
          <button
            style={{
              float: "right",
              border: "none",
              color: "#d91a5f",
              padding: "3px",
            }}
            onClick={(e) => handleOnClick(e)}
          >
            <h4>Add Timesheet</h4>
          </button>
          <h3>
            There is no practice available.
            <br />
            make sure there is a practice available.
          </h3>
          <button
            className="sel-practice-btn"
            onClick={() => navigate("/login")}
          >
            Login
          </button>
        </div>
      </Modal>
    );
  }
  return (
    <Modal open={openModal} onClose={onClose}>
      <div className="sel-practice-modal">
        <h3>Select Practice</h3>
        <button
          style={{
            float: "right",
            border: "none",
            color: "#d91a5f",
            padding: "3px",
          }}
          onClick={(e) => handleOnClick(e)}
        >
          <h4>Add Timesheet</h4>
        </button>
        <RadioGroup name="practice" value={select} onChange={onSelectPractice}>
          {practices.map((x) => {
            return (
              <FormControlLabel
                value={x.practice_id.toString()}
                control={<Radio />}
                label={x.practice_name}
                key={x.practice_id}
              />
            );
          })}
        </RadioGroup>
        <button className="sel-practice-btn" onClick={() => handleSelect()}>
          Select
        </button>
      </div>
    </Modal>
  );
};

export default PracticeRedirectPage;
